import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lohi-omma-container',
  templateUrl: './omma-container.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OmmaContainerComponent {
  constructor() {}
}
